"use client";

import { c as _c } from "react/compiler-runtime";
import { BadgeCheck, Bell, ChevronsUpDown, CreditCard, LogOut, Moon, Monitor, Plug, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useRouter } from "next/navigation";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from "@/components/ui/sidebar";
import { useAuth } from "@/contexts/auth-context";
export function NavUser(t0) {
  const $ = _c(89);
  const {
    user
  } = t0;
  const {
    isMobile
  } = useSidebar();
  const router = useRouter();
  const {
    logout
  } = useAuth();
  const {
    theme,
    setTheme
  } = useTheme();
  let t1;
  if ($[0] !== logout) {
    t1 = () => {
      logout();
    };
    $[0] = logout;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleLogout = t1;
  let t2;
  if ($[2] !== router) {
    t2 = () => {
      router.push("/dashboard/billing");
    };
    $[2] = router;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleNavigateToBilling = t2;
  let t3;
  if ($[4] !== router) {
    t3 = () => {
      router.push("/dashboard/settings/notifications");
    };
    $[4] = router;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleNavigateToNotificationSettings = t3;
  let t4;
  if ($[6] !== router) {
    t4 = () => {
      router.push("/dashboard/plugins");
    };
    $[6] = router;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleNavigateToConnectedApps = t4;
  let t5;
  if ($[8] !== user.avatar || $[9] !== user.name) {
    t5 = <AvatarImage src={user.avatar} alt={user.name} />;
    $[8] = user.avatar;
    $[9] = user.name;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <AvatarFallback className="rounded-lg">CN</AvatarFallback>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5) {
    t7 = <Avatar className="h-8 w-8 rounded-lg">{t5}{t6}</Avatar>;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== user.name) {
    t8 = <span className="truncate font-medium">{user.name}</span>;
    $[14] = user.name;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== user.email) {
    t9 = <span className="text-xs text-muted-foreground">{user.email}</span>;
    $[16] = user.email;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <div className="grid flex-1 text-left text-sm leading-tight">{t8}{t9}</div>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ChevronsUpDown className="ml-auto size-4" />;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t7 || $[24] !== user.name) {
    t12 = <DropdownMenuTrigger asChild={true}><SidebarMenuButton size="lg" className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground" tooltip={user.name}>{t7}{t10}{t11}</SidebarMenuButton></DropdownMenuTrigger>;
    $[22] = t10;
    $[23] = t7;
    $[24] = user.name;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const t13 = isMobile ? "bottom" : "right";
  let t14;
  if ($[26] !== user.avatar || $[27] !== user.name) {
    t14 = <AvatarImage src={user.avatar} alt={user.name} />;
    $[26] = user.avatar;
    $[27] = user.name;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <AvatarFallback className="rounded-lg">CN</AvatarFallback>;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t14) {
    t16 = <Avatar className="h-8 w-8 rounded-lg">{t14}{t15}</Avatar>;
    $[30] = t14;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== user.name) {
    t17 = <span className="truncate font-medium">{user.name}</span>;
    $[32] = user.name;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== user.email) {
    t18 = <span className="text-xs text-muted-foreground">{user.email}</span>;
    $[34] = user.email;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t17 || $[37] !== t18) {
    t19 = <div className="grid flex-1 text-left text-sm leading-tight">{t17}{t18}</div>;
    $[36] = t17;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t16 || $[40] !== t19) {
    t20 = <DropdownMenuLabel className="p-0 font-normal"><div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">{t16}{t19}</div></DropdownMenuLabel>;
    $[39] = t16;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <DropdownMenuSeparator />;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <DropdownMenuLabel>Appearance</DropdownMenuLabel>;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  const t23 = theme ?? "system";
  let t24;
  if ($[44] !== setTheme) {
    t24 = value => setTheme(value as "light" | "dark" | "system");
    $[44] = setTheme;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <DropdownMenuRadioItem value="light"><Sun className="size-4" />Light</DropdownMenuRadioItem>;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <DropdownMenuRadioItem value="dark"><Moon className="size-4" />Dark</DropdownMenuRadioItem>;
    $[47] = t26;
  } else {
    t26 = $[47];
  }
  let t27;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <DropdownMenuRadioItem value="system"><Monitor className="size-4" />System</DropdownMenuRadioItem>;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] !== t23 || $[50] !== t24) {
    t28 = <DropdownMenuGroup>{t22}<DropdownMenuRadioGroup value={t23} onValueChange={t24}>{t25}{t26}{t27}</DropdownMenuRadioGroup></DropdownMenuGroup>;
    $[49] = t23;
    $[50] = t24;
    $[51] = t28;
  } else {
    t28 = $[51];
  }
  let t29;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <DropdownMenuSeparator />;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <DropdownMenuItem><BadgeCheck />Account</DropdownMenuItem>;
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  let t31;
  if ($[54] !== handleNavigateToConnectedApps) {
    t31 = event => {
      event.preventDefault();
      handleNavigateToConnectedApps();
    };
    $[54] = handleNavigateToConnectedApps;
    $[55] = t31;
  } else {
    t31 = $[55];
  }
  let t32;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <Plug />;
    $[56] = t32;
  } else {
    t32 = $[56];
  }
  let t33;
  if ($[57] !== handleNavigateToConnectedApps || $[58] !== t31) {
    t33 = <DropdownMenuItem onSelect={t31} onClick={handleNavigateToConnectedApps}>{t32}Plugins</DropdownMenuItem>;
    $[57] = handleNavigateToConnectedApps;
    $[58] = t31;
    $[59] = t33;
  } else {
    t33 = $[59];
  }
  let t34;
  if ($[60] !== handleNavigateToBilling) {
    t34 = event_0 => {
      event_0.preventDefault();
      handleNavigateToBilling();
    };
    $[60] = handleNavigateToBilling;
    $[61] = t34;
  } else {
    t34 = $[61];
  }
  let t35;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <CreditCard />;
    $[62] = t35;
  } else {
    t35 = $[62];
  }
  let t36;
  if ($[63] !== handleNavigateToBilling || $[64] !== t34) {
    t36 = <DropdownMenuItem onSelect={t34} onClick={handleNavigateToBilling}>{t35}Billing</DropdownMenuItem>;
    $[63] = handleNavigateToBilling;
    $[64] = t34;
    $[65] = t36;
  } else {
    t36 = $[65];
  }
  let t37;
  if ($[66] !== handleNavigateToNotificationSettings) {
    t37 = event_1 => {
      event_1.preventDefault();
      handleNavigateToNotificationSettings();
    };
    $[66] = handleNavigateToNotificationSettings;
    $[67] = t37;
  } else {
    t37 = $[67];
  }
  let t38;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <Bell />;
    $[68] = t38;
  } else {
    t38 = $[68];
  }
  let t39;
  if ($[69] !== handleNavigateToNotificationSettings || $[70] !== t37) {
    t39 = <DropdownMenuItem onSelect={t37} onClick={handleNavigateToNotificationSettings}>{t38}Notifications</DropdownMenuItem>;
    $[69] = handleNavigateToNotificationSettings;
    $[70] = t37;
    $[71] = t39;
  } else {
    t39 = $[71];
  }
  let t40;
  if ($[72] !== t33 || $[73] !== t36 || $[74] !== t39) {
    t40 = <DropdownMenuGroup>{t30}{t33}{t36}{t39}</DropdownMenuGroup>;
    $[72] = t33;
    $[73] = t36;
    $[74] = t39;
    $[75] = t40;
  } else {
    t40 = $[75];
  }
  let t41;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <DropdownMenuSeparator />;
    $[76] = t41;
  } else {
    t41 = $[76];
  }
  let t42;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <LogOut />;
    $[77] = t42;
  } else {
    t42 = $[77];
  }
  let t43;
  if ($[78] !== handleLogout) {
    t43 = <DropdownMenuItem onClick={handleLogout}>{t42}Log out</DropdownMenuItem>;
    $[78] = handleLogout;
    $[79] = t43;
  } else {
    t43 = $[79];
  }
  let t44;
  if ($[80] !== t13 || $[81] !== t20 || $[82] !== t28 || $[83] !== t40 || $[84] !== t43) {
    t44 = <DropdownMenuContent className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg" side={t13} align="end" sideOffset={4}>{t20}{t21}{t28}{t29}{t40}{t41}{t43}</DropdownMenuContent>;
    $[80] = t13;
    $[81] = t20;
    $[82] = t28;
    $[83] = t40;
    $[84] = t43;
    $[85] = t44;
  } else {
    t44 = $[85];
  }
  let t45;
  if ($[86] !== t12 || $[87] !== t44) {
    t45 = <SidebarMenu><SidebarMenuItem><DropdownMenu>{t12}{t44}</DropdownMenu></SidebarMenuItem></SidebarMenu>;
    $[86] = t12;
    $[87] = t44;
    $[88] = t45;
  } else {
    t45 = $[88];
  }
  return t45;
}